<icon [iconName]="fileType" [title]="fileName" (onTrigger)="onTrigger.emit()"></icon>
